"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.calculateFileProgress = exports.processUploadJobs = exports.collectUploadJobs = exports.createUUID = void 0;
/*
Refactor/expension plan:
- If no message is returned from WS, check read side
- Create more unit tests
- Define chunk size based on connection speed
*/
var api_1 = require("./api");
var Chunk_1 = __importDefault(require("./Chunk"));
var constants_1 = require("./constants");
var FileUpload_1 = __importDefault(require("./FileUpload"));
var chunkHelper = __importStar(require("./helpers/chunking"));
var uuid_1 = __importDefault(require("./helpers/uuid"));
var State_1 = __importDefault(require("./State"));
var uploader_1 = require("./types/uploader");
var websocket = __importStar(require("./websocket"));
var worker = __importStar(require("./worker"));
var log = __importStar(require("./helpers/logger"));
var $state = new State_1.default();
window.uploaderState = $state;
// Export fn in the main file, so it can be used outside of the library.
var createUUID = function () { return (0, uuid_1.default)(); };
exports.createUUID = createUUID;
function collectUploadJobs(availableJobs, currentUploaders, currentJobs) {
    var jobs = [];
    if (availableJobs < 1) {
        return jobs;
    }
    var _loop_1 = function (uploader) {
        var chunks = uploader.getChunks();
        var fileQueue = uploader.getFileQueue();
        var filesThatShouldBeUploading = fileQueue.slice(0, constants_1.MAX_JOBS);
        // TODO: Investigate if the max num of uploading files can be expanded seperatly from the MAX_JOBS
        log.info('File queue:', fileQueue);
        log.info('FileUploads that should be uploading:', filesThatShouldBeUploading);
        var _loop_2 = function (chunk) {
            var fileUpload = $state.fileUploads.getByFileId(chunk.fileId);
            if (fileUpload) {
                // Array.every() returns true on empty array
                var isUnprocessedChunk = currentJobs.every(function (job) {
                    return !chunk.isDone &&
                        job.chunk.id !== chunk.id &&
                        filesThatShouldBeUploading.includes(fileUpload.id);
                });
                if (isUnprocessedChunk && chunk.isDone === false) {
                    jobs.push({ chunk: chunk, uploader: uploader });
                    if (jobs.length === availableJobs) {
                        return { value: jobs };
                    }
                }
            }
        };
        for (var _a = 0, chunks_1 = chunks; _a < chunks_1.length; _a++) {
            var chunk = chunks_1[_a];
            var state_2 = _loop_2(chunk);
            if (typeof state_2 === "object")
                return state_2;
        }
    };
    for (var _i = 0, currentUploaders_1 = currentUploaders; _i < currentUploaders_1.length; _i++) {
        var uploader = currentUploaders_1[_i];
        var state_1 = _loop_1(uploader);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return jobs;
}
exports.collectUploadJobs = collectUploadJobs;
// processFileQueue
function processUploadJobs(incomingUploadJobs) {
    if (incomingUploadJobs === void 0) { incomingUploadJobs = $state.uploadJobs.getAll(); }
    var uploadJobs = $state.uploadJobs.getAll();
    if (uploadJobs !== incomingUploadJobs) {
        $state.uploadJobs.setAll(incomingUploadJobs);
    }
    var uploaders = $state.uploaders.getAll();
    var collectedUploadJobs = collectUploadJobs(constants_1.MAX_JOBS - incomingUploadJobs.length, uploaders, incomingUploadJobs);
    collectedUploadJobs.forEach(function (uploadJob) {
        // start actual upload
        $state.uploadJobs.add(uploadJob);
        worker.uploadChunk(uploadJob, $state);
    });
}
exports.processUploadJobs = processUploadJobs;
function calculateFileProgress(id, fileId, chunkProgress) {
    if (!$state.fileUploads.getByFileId(fileId)) {
        return;
    }
    $state.uploadJobs.chunks.updateChunkProgress(id, chunkProgress);
    var _a = $state.fileUploads.getByFileId(fileId), chunksCount = _a.chunksCount, chunksDoneCount = _a.chunksDoneCount;
    var progressOfUploadingChunks = $state.uploadJobs
        .getByFileId(fileId)
        .filter(function (uploadJob) { return uploadJob.chunk.isDone !== true; })
        .map(function (uploadJob) { return uploadJob.chunk.progress; });
    var sumOfProgressOfUploadingChunks = progressOfUploadingChunks.length
        ? progressOfUploadingChunks.reduce(function (acc, value) { return acc + value; }) / 100
        : 1;
    var fileProgress = chunksDoneCount / chunksCount +
        sumOfProgressOfUploadingChunks / chunksCount;
    return Math.round(fileProgress * 100);
}
exports.calculateFileProgress = calculateFileProgress;
var Uploader = /** @class */ (function () {
    function Uploader(events, intent, isPublic) {
        if (isPublic === void 0) { isPublic = false; }
        this.events = events;
        this.intent = intent;
        this.fileQueue = [];
        this.$chunks = [];
        this.isPublic = isPublic;
        this.status = uploader_1.Status.idle;
        log.initLogger();
    }
    Uploader.prototype.chunkDoneUploading = function (id) {
        // Remove chunk from list of chunks for this uploader
        this.$chunks = this.$chunks.map(function (chunk) {
            if (chunk.id === id) {
                chunk.isDone = true;
            }
            return chunk;
        });
        // Remove chunk from currently processing upload jobs to make room for new jobs
        var remainingUploadJobs = $state.uploadJobs.chunks.remove(id);
        if (remainingUploadJobs.length) {
            processUploadJobs(remainingUploadJobs);
        }
        else {
            processUploadJobs();
        }
    };
    Uploader.prototype.removeFileFromQueue = function (fileId) {
        var fileUpload = $state.fileUploads.getByFileId(fileId);
        this.fileQueue = this.fileQueue.filter(function (id) { return id !== fileUpload.id; });
        $state.fileUploads.remove(fileId);
        processUploadJobs();
    };
    Uploader.prototype.retryChunkForFile = function (fileUpload, chunkNumber) {
        var _this = this;
        var fileId = fileUpload.fileId;
        $state.fileUploads.decrementChunksDoneCount(fileId);
        this.$chunks = this.$chunks.map(function (chunk) {
            if (chunk.fileId === fileId && chunk.number === chunkNumber + 1) {
                chunk.isDone = false;
                chunk.progress = 0;
                _this.events.onProgress(fileId, calculateFileProgress(chunk.id, chunk.fileId, 0), fileUpload.id);
            }
            return chunk;
        });
        processUploadJobs();
    };
    Uploader.prototype.cancelUpload = function (fileId) {
        this.removeFileFromQueue(fileId);
        // Remove all chunks for this file from list of chunks
        this.$chunks = this.$chunks.filter(function (chunk) { return chunk.fileId !== fileId; });
        var jobs = $state.uploadJobs.getByFileId(fileId);
        jobs.forEach(function (job) {
            if (job) {
                if (job.requestSource) {
                    job.requestSource.cancel();
                }
                processUploadJobs();
            }
        });
        $state.uploadJobs.removeByFileId(fileId);
    };
    Uploader.prototype.getChunks = function () {
        return this.$chunks;
    };
    // TODO: Add this to the upload method. Currently only using this for testing purposes
    Uploader.prototype.addChunk = function (chunk) {
        this.$chunks.push(chunk);
    };
    Uploader.prototype.getFileQueue = function () {
        return this.fileQueue;
    };
    Uploader.prototype.getStatus = function () {
        return this.status;
    };
    Uploader.prototype.createNewFileUpload = function (file) {
        var numberOfChunks = chunkHelper.calculateNumberOfChunks(file.size);
        var fileUpload = new FileUpload_1.default(file, file.name, file.size, numberOfChunks, this // uploader
        );
        $state.fileUploads.add(fileUpload);
        this.fileQueue.push(fileUpload.id);
        if (this.events.onFileUploadCreated) {
            this.events.onFileUploadCreated(fileUpload);
        }
        return fileUpload;
    };
    Uploader.prototype.prepareUpload = function (fileUpload) {
        return __awaiter(this, void 0, void 0, function () {
            var response, fileId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, api_1.prepare)(this.isPublic)];
                    case 1:
                        response = _a.sent();
                        fileId = response.data.file_id;
                        $state.fileUploads.setFileId(fileUpload.id, fileId);
                        this.events.onUploadPrepared(fileUpload.id, fileId);
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    Uploader.prototype.chunkNextFileUpload = function () {
        var fileUpload = $state.fileUploads
            .getAll()
            .find(function (fileUpload) { return !fileUpload.isChunked; });
        if (fileUpload) {
            log.info("Chunking: ".concat(fileUpload.id));
            $state.fileUploads.setIsChunked(fileUpload.id);
            this.chunkFile(fileUpload.file, fileUpload.fileId);
        }
    };
    Uploader.prototype.chunkFile = function (file, fileId) {
        var _this = this;
        var chunksCount = chunkHelper.calculateNumberOfChunks(file.size);
        var chunkNumber = 1;
        var addChunkToUploadQueue = function (chunkData, chunkHash) {
            if (!$state.fileUploads.getByFileId(fileId)) {
                return;
            }
            var chunk = new Chunk_1.default((0, exports.createUUID)(), fileId, chunkData, chunkHash, chunkNumber);
            _this.$chunks.push(chunk);
            processUploadJobs();
        };
        // ASYNC
        // Perhaps we should extract the callback into a separate piece of code.
        // Check for a cancellation from within the callback so chunks
        // don't get added to the queue anymore
        chunkHelper.chunkFileAndCalculateHash({ id: fileId, file: file }, {
            onChunkAndHashReady: function (chunkData, chunkHash) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (chunkNumber === chunksCount) {
                        this.chunkNextFileUpload();
                    }
                    addChunkToUploadQueue(chunkData, chunkHash);
                    chunkNumber++;
                    return [2 /*return*/];
                });
            }); }
        }, $state);
    };
    Uploader.prototype.newUpload = function (files, onFileUploadsCreated) {
        return __awaiter(this, void 0, void 0, function () {
            var fileUploads, prepareUploadPromises, _i, files_1, file, fileUpload;
            var _this = this;
            return __generator(this, function (_a) {
                fileUploads = [];
                prepareUploadPromises = [];
                log.info('Starting upload');
                for (_i = 0, files_1 = files; _i < files_1.length; _i++) {
                    file = files_1[_i];
                    try {
                        fileUpload = this.createNewFileUpload(file);
                        prepareUploadPromises.push(this.prepareUpload(fileUpload));
                        fileUploads.push(fileUpload);
                    }
                    catch (error) {
                        console.log(error);
                    }
                }
                return [2 /*return*/, Promise.all(prepareUploadPromises).then(function () {
                        log.info("Prepared all uploads: ".concat(fileUploads.length));
                        _this.chunkNextFileUpload();
                        if (onFileUploadsCreated && typeof onFileUploadsCreated === 'function') {
                            onFileUploadsCreated(fileUploads);
                        }
                        _this.status = uploader_1.Status.processing;
                        processUploadJobs();
                        return new Promise(function (resolve) {
                            resolve(fileUploads);
                        });
                    })];
            });
        });
    };
    return Uploader;
}());
exports.default = Uploader;
var isValidIntent = function (intent) {
    return constants_1.INTENTS.some(function (validIntent) { return intent === validIntent; });
};
var create = function (events, intent, isPublic, state) {
    if (intent === void 0) { intent = constants_1.DEFAULT_INTENT; }
    if (state === void 0) { state = $state; }
    if (!isValidIntent(intent)) {
        console.error("The intent \"".concat(intent, "\" invalid.\n      Change the intent or add the intent to the list of intents"));
        return;
    }
    var uploader = new Uploader(__assign(__assign({}, constants_1.DEFAULT_EVENTS), events), intent, isPublic);
    state.uploaders.add(uploader);
    websocket.createWebsocketConnection(isPublic);
    return uploader;
};
exports.create = create;
//# sourceMappingURL=uploader.js.map